import React, { Component } from "react";
import {
  Button,
  Row,
  Col,
  Input,
  InputNumber,
  Select,
  Radio,
} from "../../../../GeneralComponents/ui";
import i18n from "../../../../../Utils/i18next";
import uuid from "react-uuid";
import { TYPE_INPUT, TYPE_SLIDER } from "./WhatIf";
import { convertNumber } from "./Parameter";
import { decideSeparator } from "../../../../../Utils/NumberLocalization";
import { getPopupContainer } from "../../../../../Utils/Global";
import { showNotificationWithIcon } from "../../../../../Utils/Notification";

const { Option } = Select;
const numberSeparator = decideSeparator();

/** What creation and edit operations. */
export default class CreateUpdate extends Component {
  constructor(props) {
    super(props);

    this.initialState = {
      id: undefined,
      name: "",
      displayName: "",
      defaultValue: null,
      currentValue: null,
      minValue: null,
      maxValue: null,
      incrementValue: 1,
      dataType: "decimal",
      showType: TYPE_SLIDER,
    };

    this.state = { ...this.initialState };
  }

  componentDidMount() {
    if (this.props.parameter !== undefined) {
      this.setState({ ...this.props.parameter });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.parameter !== this.props.parameter) {
      if (this.props.parameter === undefined) {
        this.setState({ ...this.initialState });
      } else {
        this.setState({ ...this.props.parameter });
      }
    }
  }

  /** Handle changing input and set new value */
  handleChange = (e) => {
    this.setState({
      ...this.state,
      [e.target.id]: e.target.value,
    });
  };

  /** Handle changing number inputs and sets new value */
  handleChangeNumber = (e, field) => {
    let value = e;

    this.setState({
      ...this.state,
      [field]: value,
    });
  };

  /** Handle data type and set new value */
  handleChangeDataType = (value) => {
    this.setState({
      ...this.state,
      dataType: value,
    });
  };

  /** Handle show type and set new value */
  handleChangeShowType = (e) => {
    this.setState({
      ...this.state,
      showType: e.target.value,
    });
  };

  /** What if apply button */
  applyButton = (
    <Button
      type="primary"
      style={{ minWidth: "90px" }}
      onClick={() => this.apply()}
    >
      {i18n.t("Apply")}
    </Button>
  );

  /** What if set default button */
  clearButton = (
    <Button
      onClick={() => this.clear()}
      style={{ minWidth: "90px" }}
    >
      {i18n.t("Default")}
    </Button>
  );

  /** What if edit cancel button */
  cancelButton = (
    <Button
      onClick={() => this.cancel()}
      style={{ minWidth: "90px" }}
    >
      {i18n.t("Cancel")}
    </Button>
  );

  /** Add a parameter for what if with validation */
  apply = () => {
    let parameter = { ...this.state };
    let validation = this.applyValidation(parameter);

    if (validation.status) {
      if (parameter.id === undefined) {
        parameter.id = uuid();
      }

      parameter.currentValue = parameter.defaultValue;
      this.props.applyWhatIfParameter(parameter);
      this.clear();
    } else {
      showNotificationWithIcon(i18n.t("Error"), validation.message, "error");
    }
  };

  /** Checks any value is empty */
  isEmpty = (value) => {
    if (value === "" || value === null) {
      return true;
    }

    return false;
  };

  /** Validation for parameter */
  applyValidation = (parameter) => {
    let result = { status: true, message: "success" };

    if (
      //any parameter cannot be empty
      this.isEmpty(parameter.name) ||
      this.isEmpty(parameter.displayName) ||
      this.isEmpty(parameter.defaultValue) ||
      this.isEmpty(parameter.minValue) ||
      this.isEmpty(parameter.maxValue)
    ) {
      result.status = false;
      result.message = i18n.t(
        "Dashboard.Data.WhatIf.CreateUpdate.NoBlankSpaceCanBeLeft",
      );
    } else if (
      // if show type slider, increment value cannot be empty.
      parameter.showType === TYPE_SLIDER &&
      this.isEmpty(parameter.incrementValue)
    ) {
      result.status = false;
      result.message = i18n.t(
        "Dashboard.Data.WhatIf.CreateUpdate.NoBlankSpaceCanBeLeft",
      );
    } else if (
      parameter.showType === TYPE_SLIDER &&
      convertNumber(parameter.incrementValue, parameter.dataType) <= 0
    ) {
      result.status = false;
      result.message = i18n.t(
        "Dashboard.Data.WhatIf.CreateUpdate.IncrementValueMustBeGreaterThanZero",
      );
    } else if (
      //default value cannot be lower than min value.
      convertNumber(parameter.defaultValue, parameter.dataType) <
      convertNumber(parameter.minValue, parameter.dataType)
    ) {
      result.status = false;
      result.message = i18n.t(
        "Dashboard.Data.WhatIf.CreateUpdate.DefaultValueCannotBeLowerThanMinValue",
      );
    } else if (
      //default value cannot be greater than max value.
      convertNumber(parameter.defaultValue, parameter.dataType) >
      convertNumber(parameter.maxValue, parameter.dataType)
    ) {
      result.status = false;
      result.message = i18n.t(
        "Dashboard.Data.WhatIf.CreateUpdate.DefaultValueCannotBeGreaterThanMaxValue",
      );
    } else if (
      //increment value cannot be greater then difference of max value and min value.
      convertNumber(parameter.incrementValue, parameter.dataType) >
      convertNumber(parameter.maxValue, parameter.dataType) -
        convertNumber(parameter.minValue, parameter.dataType)
    ) {
      result.status = false;
      result.message = i18n.t(
        "Dashboard.Data.WhatIf.CreateUpdate.IncrementValueCannotBeGreaterThanDifferenceOfMaxValueAndMinValue",
      );
    }

    return result;
  };

  /** clear what if creation */
  clear = () => {
    this.setState({ ...this.initialState });
  };

  /** Cancel what if create and update */
  cancel = () => {
    this.setState({ ...this.initialState });
    this.props.cancelEditParameter();
  };

  render() {
    const labelStyle = {
      display: "block",
      marginBottom: "4px",
      fontSize: "12px",
      fontWeight: "600",
      color: "#8c8c8c",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    };

    return (
      <div className={"whatIf-create-update"} style={{ padding: "0 10px" }}>
        <Row align="middle" style={{ marginBottom: "28px", paddingBottom: "16px", borderBottom: "1px solid #f0f0f0" }}>
          <Col span={10}>
            <span style={{ fontWeight: "600", fontSize: "14px" }}>
              {i18n.t("Dashboard.Data.WhatIf.CreateUpdate.ShowType")}:
            </span>
          </Col>
          <Col span={14}>
            <Radio.Group onChange={this.handleChangeShowType} value={this.state.showType} buttonStyle="solid" style={{ width: '100%', display: 'flex' }}>
              <Radio.Button value={TYPE_SLIDER} style={{ flex: 1, textAlign: 'center' }}>
                {i18n.t("Dashboard.Data.WhatIf.CreateUpdate.Slider")}
              </Radio.Button>
              <Radio.Button value={TYPE_INPUT} style={{ flex: 1, textAlign: 'center' }}>
                {i18n.t("Dashboard.Data.WhatIf.CreateUpdate.Input")}
              </Radio.Button>
            </Radio.Group>
          </Col>
        </Row>

        <Row gutter={[16, 16]} style={{ marginBottom: "24px" }}>
          <Col span={24}>
            <label style={labelStyle}>{i18n.t("Dashboard.Data.WhatIf.CreateUpdate.Name")}:</label>
            <Input id={"name"} onChange={this.handleChange} value={this.state.name} />
          </Col>
          <Col span={24}>
            <label style={labelStyle}>{i18n.t("Dashboard.Data.WhatIf.CreateUpdate.DisplayName")}:</label>
            <Input id={"displayName"} onChange={this.handleChange} value={this.state.displayName} />
          </Col>
          <Col span={24}>
            <label style={labelStyle}>{i18n.t("Dashboard.Data.WhatIf.CreateUpdate.DataType")}:</label>
            <Select
              showSearch
              style={{ width: "100%" }}
              getPopupContainer={getPopupContainer}
              id={"dataType"}
              defaultValue={this.state.dataType}
              value={this.state.dataType}
              onChange={this.handleChangeDataType}
            >
              <Option value="integer">{i18n.t("Dashboard.Data.WhatIf.CreateUpdate.Integer")}</Option>
              <Option value="decimal">{i18n.t("Dashboard.Data.WhatIf.CreateUpdate.Decimal")}</Option>
              <Option value="percent">{i18n.t("Dashboard.Data.WhatIf.CreateUpdate.Percent")}</Option>
            </Select>
          </Col>
        </Row>

        <Row gutter={[8, 8]} style={{ marginBottom: "32px" }}>
          <Col span={6}>
            <label style={labelStyle}>{i18n.t("Dashboard.Data.WhatIf.CreateUpdate.MinValue")}:</label>
            <InputNumber id={"minValue"} style={{ width: '100%' }} onChange={(e) => this.handleChangeNumber(e, "minValue")} value={this.state.minValue} decimalSeparator={numberSeparator} />
          </Col>
          <Col span={6}>
            <label style={labelStyle}>{i18n.t("Dashboard.Data.WhatIf.CreateUpdate.MaxValue")}:</label>
            <InputNumber id={"maxValue"} style={{ width: '100%' }} onChange={(e) => this.handleChangeNumber(e, "maxValue")} value={this.state.maxValue} decimalSeparator={numberSeparator} />
          </Col>
          <Col span={6}>
            <label style={labelStyle}>{i18n.t("Dashboard.Data.WhatIf.CreateUpdate.DefaultValue")}:</label>
            <InputNumber id={"defaultValue"} style={{ width: '100%' }} onChange={(e) => this.handleChangeNumber(e, "defaultValue")} value={this.state.defaultValue} decimalSeparator={numberSeparator} />
          </Col>
          <Col span={6}>
            {this.state.showType === TYPE_SLIDER ? (
              <>
                <label style={labelStyle}>{i18n.t("Dashboard.Data.WhatIf.CreateUpdate.IncrementValue")}:</label>
                <InputNumber id={"incrementValue"} style={{ width: '100%' }} onChange={(e) => this.handleChangeNumber(e, "incrementValue")} value={this.state.incrementValue} decimalSeparator={numberSeparator} />
              </>
            ) : null}
          </Col>
        </Row>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "20px", borderTop: "1px solid #f0f0f0", paddingTop: "24px" }}>
          {this.state.id === undefined ? this.clearButton : this.cancelButton}
          {this.applyButton}
        </div>
      </div>
    );
  }
}